const toggleButtons = document.querySelectorAll('.js-searchToggle');
const searchContainer = document.querySelector('.js-search');
const searchInput = document.querySelector('.js-searchInput');

toggleButtons.forEach(button => {
    button.addEventListener('click', function () {
        const isOpen = searchContainer.classList.toggle('-open');
        if (isOpen) {
            requestAnimationFrame(() => searchInput.focus());
        }
    });
});